import React, { useEffect, useState } from 'react';

/**
 * OAuthCallback component handles the OAuth callback from the authorization server.
 * It extracts the authorization code or error from the URL query parameters and
 * posts the result to the opener window (if available).
 */

export default function OAuthCallback() {
  const [authCode, setAuthCode] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const err = params.get('error');
    if (code) {
      setAuthCode(code);
      if (window.opener) {
        // Debug log for extension communication
        if (typeof window.dbgLog === 'function') window.dbgLog('Posting code to opener:', code);
        window.opener.postMessage({ code }, '*');
        // Attempt to close the popup (may be blocked by browser if not opened by script)
        setTimeout(() => {
          try {
            window.close();
          } catch (e) {
            if (typeof window.dbgWarn === 'function') window.dbgWarn('window.close() blocked:', e);
          }
        }, 100);
      } else {
        if (typeof window.dbgWarn === 'function') window.dbgWarn('No opener window to post code to.');
      }
    } else if (err) {
      setError(err);
      if (window.opener) {
        if (typeof window.dbgWarn === 'function') window.dbgWarn('Posting error to opener:', err);
        window.opener.postMessage({ error: err }, '*');
        // Attempt to close after sending error
        setTimeout(() => {
          try {
            window.close();
          } catch (e) {
            if (typeof window.dbgWarn === 'function') window.dbgWarn('window.close() blocked:', e);
          }
        }, 100);
      }
    }
  }, []);

  return (
    <div style={{ padding: 32 }}>
      <h2>OAuth Callback</h2>
      {authCode && (
        <>
          <div>Authorization code:</div>
          <pre style={{ background: '#eee', padding: 8 }}>{authCode}</pre>
        </>
      )}
      {error && (
        <>
          <div style={{ color: 'red' }}>Error: {error}</div>
        </>
      )}
      {!authCode && !error && <div>Processing...</div>}
    </div>
  );
}
